import account from '@/api/accounts'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    account.getAccount(result => {
      if (result.status === 200) {
        commit('setAccountInfo', result.data.data)
      }
      resolve(result)
    }, param)
  })
}
